import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {array, mixed, object, string} from 'yup'

import {COMMENT_MAX_LENGTH, getYesNoWithCommentSchema, TEXT_MAX_LENGTH} from './yes-no.validators'

const readingSchema = (t: TFunction) =>
  object().shape({
    normal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    full: string().max(TEXT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})),
    comment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    )
  })

const grateReadingSchema = (t: TFunction) =>
  object().shape({
    normal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    missing: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    comment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    )
  })

export const getCoolerSectionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    compartments: array().of(readingSchema(t)),
    gates: array().of(grateReadingSchema(t)),
    coolerDrivesOperatingProperly: object().shape({
      value: mixed().oneOf(['yes', 'no']).required(),
      valueRetake: mixed().oneOf(['yes', 'no']).required(),
      comment: string()
        .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH}))
        .when(['value', 'valueRetake'], {
          is: (value: string, valueRetake: string) => value === 'no' || valueRetake === 'no',
          then: (schema) => schema.required(t(ValidationErrorKeys.REQUIRED)),
          otherwise: (schema) => schema
        })
    }),
    coolerDrives3ShotsGrease: object().shape({
      value: mixed().oneOf(['yes', 'no']).required(),
      valueRetake: mixed().oneOf(['yes', 'no']).required(),
      comment: string()
        .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH}))
        .when(['value', 'valueRetake'], {
          is: (value: string, valueRetake: string) => value === 'no' || valueRetake === 'no',
          then: (schema) => schema.required(t(ValidationErrorKeys.REQUIRED)),
          otherwise: (schema) => schema
        })
    }),
    megaBlastersOperatingProperly: object().shape({
      value: mixed().oneOf(['yes', 'no']).required(),
      valueRetake: mixed().oneOf(['yes', 'no']).required(),
      comment: string()
        .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH}))
        .when(['value', 'valueRetake'], {
          is: (value: string, valueRetake: string) => value === 'no' || valueRetake === 'no',
          then: (schema) => schema.required(t(ValidationErrorKeys.REQUIRED)),
          otherwise: (schema) => schema
        })
    }),
    undergrateFans1To8OperatingProperly: getYesNoWithCommentSchema({t}),
    clinkerBreakerBeltsBearingsMotorOperatingProperly: getYesNoWithCommentSchema({t}),
    plattcoValvesOperatingProperly: getYesNoWithCommentSchema({t}),
    plattcoValvesAnyLeftOpen: getYesNoWithCommentSchema({t}),
    finesDrags6119And6120OperatingProperly: getYesNoWithCommentSchema({t}),
    panConveyorEastPanOperatingProperly: getYesNoWithCommentSchema({t}),
    panConveyorEastPanExcessiveSpillage: getYesNoWithCommentSchema({t}),
    panConveyorEastPanPansNormal: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    panConveyorEastPanPansDamaged: string().max(
      TEXT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: TEXT_MAX_LENGTH})
    ),
    panConveyorEastPanPansComment: string().max(
      COMMENT_MAX_LENGTH,
      t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})
    )
  })
